const ErrorTypes = {
	ERROR_REQUEST_GET: "ERROR_REQUEST_GET",
	ERROR_REQUEST_POST: "ERROR_REQUEST_POST",
	ERROR_DATA_GET: "ERROR_DATA_GET",
	ERROR_DATA_POST: "ERROR_DATA_POST",
	ERROR_ID: "ERROR_ID",

};

export default ErrorTypes;



/** WEBPACK FOOTER **
 ** ./src/constants/ErrorTypes.js
 **/